module.exports = __webpack_public_path__ + "media/box_select.37c869dc.mp3";